import React, { useState } from "react";

import { Form, Input, Select, Button, Col, Row } from "antd";
import { v4 as uuidv4 } from "uuid";
import { states } from "../../../../../utils/Util";

function OwnerAddresses({ ownerAddresses, setOwnerAddresses }) {
  const addOwnerAddress = () => {
    const newOwnerAdress = {
      id: uuidv4(),
    };
    setOwnerAddresses([...ownerAddresses, newOwnerAdress]);
  };

  const removeOwnerAddress = (id) => {
    const updatedOwnerAddresses = ownerAddresses.filter(
      (item) => item.id !== id
    );
    setOwnerAddresses(updatedOwnerAddresses);
  };

  const handleChange = (value, name, id) => {
    const updatedOwnerAddresses = ownerAddresses.map((item) => {
      if (item.id === id) {
        return { ...item, [name]: value };
      }
      return item;
    });
    setOwnerAddresses(updatedOwnerAddresses);
  };

  return (
    <ul>
      {ownerAddresses.map((item, index) => (
        <li key={item.id}>
          <Row>
            <Col span={23}>
              <Form.Item label=" " name={`ownerAddress1-${index}`}>
                <Input
                  placeholder="Address 1"
                  onChange={(e) =>
                    handleChange(e.target.value, "addressOne", item.id)
                  }
                />
              </Form.Item>
              <Form.Item label=" " name={`ownerAddress2-${index}`}>
                <Input
                  placeholder="Address 2"
                  onChange={(e) =>
                    handleChange(e.target.value, "addressTwo", item.id)
                  }
                />
              </Form.Item>
              <Row>
                <Col span={10} style={{ marginLeft: "17%" }}>
                  <Form.Item label=" " name={`ownerAdressCity-${index}`}>
                    <Input
                      placeholder="City"
                      onChange={(e) =>
                        handleChange(e.target.value, "city", item.id)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col flex={1}></Col>
                <Col flex={5} span={5}>
                  <Form.Item label=" " name={`ownerAdressState-${index}`}>
                    <Select
                      options={states}
                      onChange={(value) =>
                        handleChange(value, "state", item.id)
                      }
                    />
                  </Form.Item>
                </Col>
                <Col flex={1}></Col>
                <Col flex={2}>
                  <Form.Item label="" name={`ownerAdressZip-${index}`}>
                    <Input
                      placeholder="Zip"
                      onChange={(e) =>
                        handleChange(e.target.value, "zipCode", item.id)
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item name={`ownerAdressCountry-${index}`} label=" ">
                <Input
                  placeholder="Counntry"
                  onChange={(e) =>
                    handleChange(e.target.value, "country", item.id)
                  }
                />
              </Form.Item>
            </Col>
            <Col span={1}>
              {ownerAddresses.length > 1 ? (
                <Button
                  className="roundSmallButton"
                  onClick={() => {
                    removeOwnerAddress(item.id);
                  }}
                  type="primary"
                  shape="circle"
                  icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                  size={"small"}
                />
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </li>
      ))}
      <Form.Item label=" " style={{ paddingLeft: 12 }}>
        <Button
          className="addPropertyGroupButton"
          type="primary"
          onClick={addOwnerAddress}
          size={"small"}
          icon={<i className="fa-solid fa-circle-plus"></i>}
        >
          Add Another Address
        </Button>
      </Form.Item>
    </ul>
  );
}

export default OwnerAddresses;
